// Desktop sidebar rail: one collapsed flag for the chevron and Nastavení → Vzhled.

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'tt-sidebar-collapsed';

@Injectable({ providedIn: 'root' })
export class SidebarCollapseService {
  private readonly collapsedSubject = new BehaviorSubject<boolean>(readCollapsed());
  readonly collapsed$ = this.collapsedSubject.asObservable();

  get collapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggle(): void {
    this.setCollapsed(!this.collapsed);
  }

  setCollapsed(collapsed: boolean): void {
    if (this.collapsedSubject.value === collapsed) return;
    this.collapsedSubject.next(collapsed);
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch {
      // Private browsing — the rail still toggles for this visit.
    }
  }
}

function readCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
